import classNames from 'classnames';
import { Table, TableProps } from 'antd';
import { Flex } from '@/components';

import './styles.scss';

export interface LogTableColumn {
  key: string | any;
  title: string;
  width?: any;
  align?: any;
  render?: any;
}

export interface LogTableProps extends TableProps<any> {
  columns: LogTableColumn[];
  rows: any[];
  loading?: boolean;
  className?: string;
}

export function LogTable({
  rows,
  columns,
  className = undefined,
  loading = false,
  pagination = false,
  ...rest
}: LogTableProps) {

  columns = columns.map(th => {
    return {
      width: undefined,
      ...th,
      dataIndex: th.key,
    };
  });

  rows = rows.map((row, i) => {
    if (row.key == null) {
      row.key = String(i);
    }
    return row;
  });

  return (
    <Flex className="app-log-table-container">
      <Table
        size="middle"
        bordered={false}
        className={classNames('log-table', className)}
        showHeader={true}
        columns={columns}
        pagination={pagination as any}
        scroll={{ x: 1200 }}
        dataSource={rows}
        loading={loading}
        {...rest}
      />
    </Flex>
  );
}

export default LogTable;
